import { Component, OnInit, EventEmitter, Output, Input} from '@angular/core';
import { UserManagmentService } from './../user-managment.service';
import { ErrorHandler } from '../../../utils/error-handler.service';
import { ConfirmationDialogComponent } from '@common/confirmation-dialog/confirmation-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-roles-list',
  templateUrl: './roles-list.component.html',
  styleUrls: ['./roles-list.component.scss'],
  providers: [UserManagmentService],
})
export class RolesListComponent implements OnInit {

  @Input() roleList:  any[];

  panelMap: { [key: string]: boolean } = {};

  @Output() editChange: EventEmitter<any> = new EventEmitter<any>();

  searchByName: string;

  constructor(public userManagmentService: UserManagmentService,
              private errorHandler: ErrorHandler,
              private toastr: ToastrService,
              public dialog: MatDialog) { }

  ngOnInit() {
    this.readRoles();
  }

  public readRoles(){
    const obj = {};
    this.userManagmentService.getRoleList(obj).subscribe(
      (response) => {
        if (response.status === 0) {
          this.roleList = response.data.list;
        }
        this.errorHandler.handleError(response);
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }

  public openDialog(role) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      height: '207px',
      width: '486px',
      data: { value: role , mode: 'ROLE-DELETE'},
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status) {
        this.userManagmentService.deleteRole({ roleId: result.data.id }).subscribe(
          (response) => {
            if (response.status === 0) {
              this.toastr.success(response.message);
              this.readRoles();
            } else {
              this.errorHandler.handleError(response);
            }
            
          },
          (error) => {
            this.errorHandler.handleError(error);
            
          }
        );
      }
    });
  }

  public editRole(role: any){
    this.editChange.emit(role);
    this.scrollTop();
  }

  public scrollTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

}
